function UserReducer(state = { confirmerList: [], pageFieldList: [], userList: null, userPop: '', selectedUserPop:'', referDocumentPop:'' }, action) {

  switch (action.type) {

    case "FETCH_User_List":
      return {
        ...state,
        UsersList: action.data
      };
      case "GET_USER_LIST":
        return {
          ...state,
          userList: action.data
        }      
    case "PAGE_FIELD_LIST":
      return {
        ...state,
        pageFieldList: action.data
      }
    case "GET_USER_LIST":
      return {
        ...state,
        userList: action.data
      }
    case "USER_POP":
      return {
        ...state,
        userPop: action.data
      }
      case "SEARCH_UNREAD_REMINDERS":
        return {
          ...state,
          unreadReminders: action.data
        }      
    case "SELECTED_USER_POP":
      return {
        ...state,
        selectedUserPop: action.data
      }
      case "REFERDOC_POP":
        return{
          ...state,
          referDocumentPop: action.data
        }
    default:
      return state;
  }
}

export default UserReducer;